<template>
  <svg
    style="z-index: 2"
    class="heading"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="100%"
    height="100%"
    preserveAspectRatio="xMinYMin"
  >
    <title>{{ hint }}</title>
    <text
      x="0%"
      y="70%"
      :fill="fill"
      :class="{ 'f-heading': true, unselectable: $store.getters.editMode }"
      :style="style"
      padding="0px"
      :font-weight="fontStyle"
    >
      {{ heading_caption }}
    </text>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "heading",
  mixins: [MixinStates],
  props: {
    heading_caption: {
      type: String,
      default: "",
    },
    text_anchor: {
      type: String,
      default: "",
    },
    fill: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      style: {
        "font-size": "12px",
      },
    };
  },
  mounted() {
    this.style = {
      "font-size": (localStorage.scale ? localStorage.scale : 13) - 1 + "px",
    };
  },
};
</script>
<style>
.f-heading {
  text-anchor: start;
  font-family: var(--font-family);
}
</style>
